
const URL_BASE = process.env.VUE_APP_API_URL


export default {
    URL_API: URL_BASE+'/api',
    URL_AUTH: URL_BASE+'/oauth/',
}
